import ActionsForm from '@/shared/mixins/actionsForm'
import newTemplate from '../newTemplate/newTemplate.vue'
import { toast, loading } from '@/shared/utils/UIHelper'
import aprTemplate from '@/shared/http/repositories/business/aprTemplate'

// import Tools from '@/components/tools/Tools'

export default {
  name: 'templateTable',
  mixins: [ActionsForm],
  components: {newTemplate},
  data () {
    return {
      templateExclusao: '',
      formSearch: {},
      templateid: null,
      editar: false,
      clone: null,
      liberaClonar: false,
      dataUsuarioAPR: [],
      numeroAPRTemplate: null,
      columTemplate: ['CÓDIGO DA APR', 'STATUS', 'DT. DE CRIAÇÃO', 'REVISÃO', ''],
      form: {
        categoria: null,
        descricao: null
      },
      clonagemTemplate: true
    }
  },

  mounted () {
    this.onLoad()
  },
  methods: {
    popConfirmacaoExclusao (e) {
      this.templateid = e.id
      this.templateExclusao = e.codigoAtividade
      this.$refs['excluir-template'].show()
    },
    cancelarpopConfirmacaoExclusao () {
      this.templateid = null
      this.templateExclusao = ''
      this.$refs['excluir-template'].hide()
    },
    DetailsExpense (e) {
      this.$emit('aprDetalhes', e)
    },
    popUptAdd () {
      this.clone = null
      this.form.categoria = null
      this.form.descricao = null
      this.numeroAPRTemplate = null
      this.$refs['add-novo-template'].show()
    },
    popUptEdicao (value) {
      this.clone = null
      this.editar = false
      this.numeroAPRTemplate = null
      this.$refs['add-novo-template'].show()
    },
    avancaClonagem () {
      this.liberaClonar = true
    },
    popUptAddClonagem (data) {
      this.liberaClonar = data.descricaoStatus === 'AG. APROVAÇÃO'
      this.clone = data.id
      this.form.categoria = null
      this.form.descricao = null
      this.numeroAPRTemplate = data.codigoAtividade
      this.editar = false
      this.$refs['add-novo-template'].show()
    },
    cancelarAddTemplate () {
      this.clone = null
      this.numeroAPRTemplate = null
      this.$refs['add-novo-template'].hide()
    },
    openFiles () {
      document.getElementById('impor-ex-price').click()
    },
    imporTable (e) {
      if (e.target.files.length === 0) return
      let conf = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      console.log(conf)
      let data = new FormData()
      data.append('Excel', e.target.files[0])
      loading.push()
      aprTemplate.ImporAPR(data, conf)
        .then(Response => {
          toast.success('Excel importado com sucesso!!', 'Excel')
          this.onLoad()
          loading.pop()
        })
        .catch(Error => {
          loading.pop()
          toast.error('Formato invalido!!', 'Excel')
        })
    },
    recarregarTable () {
      this.cancelarAddTemplate()
      this.onLoad()
    },
    onLoad () {
      loading.push()
      aprTemplate.GetAPRTemplateGrid(this.$refs.tableGridsTemplateApr.pagingLimit, this.$refs.tableGridsTemplateApr.pagingIndex, this.formSearch)
        .then((Response) => {
          loading.pop()
          this.$refs.tableGridsTemplateApr.LoadAllByData(Response)
          this.dataUsuarioAPR = Response.data.data
        }).catch(Error => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    },
    popUpEdicao (value) {
      this.clone = null
      this.numeroAPRTemplate = null
      this.editar = true
      this.numeroAPRTemplate = value.codigoAtividade
      this.form.categoria = value.atividadeId
      this.templateid = value.id
      this.form.descricao = value.descricaoAtividadeId
      this.$refs['add-novo-template'].show()
    },
    removerTemplate () {
      loading.push()
      aprTemplate.DeleteTemplateApr(this.templateid)
        .then((Response) => {
          loading.pop()
          this.templateid = null
          this.$refs['excluir-template'].hide()
          this.onLoad()
          toast.success('Template excluído com sucesso!')
        }).catch(Error => {
          loading.pop()
          this.$refs['excluir-template'].hide()
          toast.error(Error.response.data)
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/templateTable/templateTable.js